import type { InterstitialImageOrGraph } from '@/api/generated-catch-backend/model/interstitialImageOrGraph';
import { InterstitialImage as InterstitialImageType } from '../../../types';
import { NextButton } from '../next-button/button';
import { BaseImageInterstitial, BaseImageOrGraphType } from './base-image-interstitial';

type InterstitialImageProps = {
  interstitial: InterstitialImageType;
  onNext?: () => void;
  onBack?: () => void;
  isBackDisabled?: boolean;
};

// Helper function to convert questionnaire graphic type to base type
const convertInterstitialGraphicToBase = (
  graphic: InterstitialImageOrGraph | null | undefined,
): BaseImageOrGraphType | null => {
  if (!graphic) return null;

  return {
    type: graphic.type satisfies 'image' | 'lottie' | 'icon' | 'custom',
    asset: graphic.asset,
    height: graphic.height,
    width: graphic.width,
    customGraphicName: null,
  };
};

export const InterstitialImage = ({ interstitial, onNext, onBack, isBackDisabled }: InterstitialImageProps) => {
  const backgroundOpacity = interstitial.backgroundOpacity ?? 0.6;

  return (
    <BaseImageInterstitial
      titleAbove={interstitial.titleAbove}
      subtitleAbove={interstitial.subtitleAbove}
      titleBelow={interstitial.titleBelow}
      subtitleBelow={interstitial.subtitleBelow}
      primaryGraphic={convertInterstitialGraphicToBase(interstitial.imageOrGraph)}
      secondaryGraphic={convertInterstitialGraphicToBase(interstitial.imageOrGraphBelow)}
      backgroundAsset={interstitial.backgroundAsset}
      backgroundOpacity={backgroundOpacity}
      card={interstitial.card}
      onNext={onNext}
      onBack={onBack}
      isBackDisabled={isBackDisabled}
      buttonText="Continue"
      renderButton={(onNextCallback, text) => <NextButton onNext={onNextCallback} text={text} />}
    />
  );
};
